import { SET_ACTIVE_PAGE } from "../constants/moba-types";

export function setActivePage(page) {
  return {
    type: SET_ACTIVE_PAGE,
    payload: page
  };
}
